import _ from 'lodash';

export const shareColumnsExtend = (modelName, columns) => {
  return _.map(columns, (hash) => {
    if (typeof hash === 'string') {
      return { key: hash, model_name: modelName }
    } else if (hash['key'] && !hash['model_name']) {
      hash['model_name'] = modelName

      return hash
    } else {
      return hash
    }
  })
}
